/* eslint-disable import/no-unresolved, no-restricted-syntax */
import Tooltip from 'bootstrap/js/dist/tooltip';

(() => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
})();
